import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface DropdownItemAvatarProps {
  className?: string;
}

/*
 * Style.
 */

const StyledAvatarDiv = styled.div`
  grid-area: left-icon;
  margin-right: 8px;
  align-self: center;
`;

/*
 * Component.
 */

export const DropdownItemAvatar: FC<PropsWithChildren<DropdownItemAvatarProps>> = ({children, className}) => (
  <StyledAvatarDiv className={className}>{children}</StyledAvatarDiv>
);
